import { fetchRarity } from "./wtg";

export default async function fetch(contractAddress, data) {
  return fetchRarity(contractAddress, data);
};
